/**
 * Sparkline — 60x24-ish tiny SVG line chart for KPI cards.
 * Pure SVG, no chart lib. Handles empty/short arrays gracefully.
 */
export default function Sparkline({
  data,
  width = 88,
  height = 28,
  stroke = "currentColor",
  fill = null,
  strokeWidth = 1.5,
  ariaLabel,
}) {
  if (!Array.isArray(data) || data.length < 2) {
    // Show a flat baseline instead of nothing — communicates "no trend yet"
    return (
      <svg width={width} height={height} aria-label={ariaLabel || "sparkline empty"}>
        <line
          x1={0} y1={height / 2} x2={width} y2={height / 2}
          stroke={stroke} strokeOpacity="0.2" strokeWidth={strokeWidth}
          strokeDasharray="2 3"
        />
      </svg>
    );
  }

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const yFor = (v) => height - 2 - ((v - min) / range) * (height - 4);

  const pathD = data.map((v, i) => `${i === 0 ? "M" : "L"}${(i * stepX).toFixed(1)} ${yFor(v).toFixed(1)}`).join(" ");
  const areaD = fill
    ? `${pathD} L${(width).toFixed(1)} ${height} L0 ${height} Z`
    : null;

  return (
    <svg width={width} height={height} aria-label={ariaLabel || "sparkline"} style={{ overflow: "visible" }}>
      {areaD && <path d={areaD} fill={fill} opacity="0.18" />}
      <path d={pathD} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      {/* Last-point dot */}
      <circle
        cx={(data.length - 1) * stepX}
        cy={yFor(data[data.length - 1])}
        r={2.2}
        fill={stroke}
      />
    </svg>
  );
}
